module.exports = "/_next/static/images/sure-cancel-98cc2c7921f16b5a82b1ac2b315db298.svg";